module.exports = __webpack_public_path__ + "img/progress_079.5f47f6fa.png";